"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".scrollDisabled_ed0f302b{overflow:hidden !important}\n" }]);
exports.scrollDisabled = "scrollDisabled_ed0f302b";
//# sourceMappingURL=scroll.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@uifabric/utilities/lib/scroll.scss.js
// module id = ../node_modules/@uifabric/utilities/lib/scroll.scss.js
// module chunks = 1